import { api } from "@shared/lib/apiClient";
import type { ReponseDoublon, TravailScrape } from "@sfs/contracts";

export const prospectionApi = {
  verifier: (url: string) => api.post<ReponseDoublon>("/scrape/verifier", { url }),
  lancer: (url: string, forcerCreation = false, prospectId: string | null = null) =>
    api.post<{ scrapeRunId: string; prospectId: string | null; doublon: ReponseDoublon }>("/scrape", { url, forcerCreation, prospectId }),
  statut: (id: string) => api.get<TravailScrape>(`/scrape/${id}`),
  lot: (urls: string[]) => api.post<{ misEnFile: number }>("/scrape/lot", { urls }),
  mesAnalyses: () => api.get<TravailScrape[]>("/scrape/mes-analyses")
};
